import { ConnectError } from '@bufbuild/connect';
import type { AnyAction, Middleware } from '@reduxjs/toolkit';
import { isRejectedWithValue } from '@reduxjs/toolkit';

import { INLINE_ERROR_CODES, UserBadRequestError } from '@/shared/config';
import { debug, safeJSONParse } from '@/shared/lib';

import { authLib, authModel } from '@/entities/auth';

import { errorToastCaller } from '@/features/errorToastCaller';

// The new password page shows its own screen for a dead link.
const isDeadResetLinkOnNewPasswordPage = (action: AnyAction) =>
  (authModel.thunks.getPasswordPolicy.rejected.match(action) ||
    authModel.thunks.setPassword.rejected.match(action)) &&
  authLib.isDeadResetLinkError(action.payload);

export const errorMiddleware: Middleware =
  () => (next) => (action: AnyAction) => {
    if (isRejectedWithValue(action)) {
      const { rawMessage } = action.payload as ConnectError;
      const { type, code } = safeJSONParse(rawMessage);

      if (!type && !code) {
        return next(action);
      }

      // NOTE: Do not show toast for internal server errors of specific services.
      // For example for all hubspot unexpected errors.
      const ignoreInternalServerError = type === 'InternalServerError';

      debug(`Receive api error: ${type}`);

      if (
        action.payload instanceof ConnectError &&
        !INLINE_ERROR_CODES.includes(code as UserBadRequestError) &&
        !ignoreInternalServerError &&
        !isDeadResetLinkOnNewPasswordPage(action)
      ) {
        errorToastCaller(action.payload as ConnectError);
      }
    }

    return next(action);
  };
